/* eslint-disable no-underscore-dangle */
import _this from '../main';
import Rest from './Rest';

export default class Notes {
  static config = undefined

  static fetchCourses = (cusParams = {}) => {
    const url = '/mini-campaign/wanke/classes';
    const params = {
      'pagination.pageIndex': 1,
      'pagination.pageSize': 200,
      ...cusParams,
    };

    return Rest.get(url, { params });
  }

  static fetchConfig = async () => {
    if (Notes.config) {
      return Notes.config;
    }

    const objKeys = [
      'circleShares',
      'channelMap',
      'activeIds',
    ];
    const commonKeys = [];
    const keys = [...objKeys, ...commonKeys];
    const { keyValuePairs } = await Rest.get('/mini-campaign/config', {
      params: {
        keys: keys.toString(),
        appId: _this.globalData.appId,
      },
    });
    let data = {};

    keyValuePairs.forEach((item) => {
      if (objKeys.indexOf(item.key) >= 0) {
        item.value = JSON.parse(item.value || {});
      }

      data = { ...data, [item.key]: item.value };
    });

    Notes.config = data;
    return data;
  }

  static generateQrCode = (params) => {
    const result = Rest.get('/mini-campaign/wanke/h5/qr', { params });
    return result;
  }

  static fetchCategories = () => {
    const url = '/mini-campaign/wanke/categories';
    return Rest.get(url);
  }

  static fetchCourse = (id) => {
    const url = `/mini-campaign/wanke/classes/${id}`;
    return Rest.get(url);
  }

  static getMpAccountInfo = (params) => {
    const url = '/mini-campaign/wanke/h5/mpaccount';
    return Rest.post(url, params);
  }

  static partnerCreateActivity = (params) => {
    const url = '/mini-campaign/wanke/partner/activity';
    return Rest.post(url, params);
  }

  static generatePartnerMpQrCode = () => {
    const params = {
      appId: _this.globalData.appId,
    };
    const url = '/mini-campaign/wanke/partner/qr';
    return Rest.get(url, { params });
  }

  static getShorten = url => Rest.get('/mini-campaign/wanke/partner/shorten', { params: { url } });
}
